import { isRunInActiveStage } from 'components/scenarios/utils'
import {
  hasAttackSteps,
  scenarioHasStatusCheck
} from 'components/scenarios/utils/graph'
import {
  GameDay,
  GameDayExecutionResult,
  ScenarioRun
} from 'types/api/gamedays/scenarios'
import { Scenario } from 'types/api/scenarios/scenario'
import { naturalSortBy } from 'utils/list'

export const VALID_GAMEDAY_TYPES: {
  [name: string]: Record<string, string | undefined>
} = {
  Exploratory: {
    label: 'Exploratory',
    description:
      'Understand your service better by testing concerns and validating theories about potential failure modes.'
  },
  TrainTeams: {
    label: 'Train Teams',
    description:
      'Practice Chaos Engineering. Choose a simple use case, such as resource exhaustion, to get familiar with how to run a GameDay.'
  },
  ValidatePastOutages: {
    label: 'Validate Past Outages',
    description:
      'Recreate a past outage to ensure that your team and your service handle it appropriately.'
  },
  TuneObservability: {
    label: 'Tune Observability',
    description:
      'Ensure that your alerting and engagement work correctly (for example, does the right person get paged or does the alert fire when it is supposed to?). Tune existing alert thresholds to reduce signal to noise. '
  },
  Other: {
    label: 'Other',
    description: undefined
  }
}

export function isScenarioUsableForGameDay(scenario: Scenario) {
  return hasAttackSteps(scenario) || scenarioHasStatusCheck(scenario.graph)
}

export function getActiveGameDayExecution(
  gameday: GameDay
): GameDayExecutionResult {
  return gameday?.execution?.results?.find((s) =>
    s.runs.find((r) => isRunInActiveStage(r))
  )
}

export function isGameDayRunning(gameday: GameDay) {
  return Boolean(getActiveGameDayExecution(gameday))
}

export function getScenarioFromGameDay(gameday: GameDay, scenarioGuid: string) {
  return gameday.execution?.results.find(
    (result) => result.scenario.guid === scenarioGuid
  )
}

export function getLatestScenarioRun(executionResult: GameDayExecutionResult) {
  const sortedRuns = naturalSortBy(
    executionResult?.runs,
    (r) => r.run_number,
    'desc'
  )
  return sortedRuns[0]
}

export function getRunResult(run: ScenarioRun): string {
  return run.results?.status || 'input results'
}
